function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7616 4.27854L11.9566 0L2.15171 4.27854L2.05389 4.67527C1.00335 8.93578 1.4637 18.6817 11.5826 23.8104L11.9566 24L12.3306 23.8104C22.4495 18.6817 22.9099 8.93579 21.8594 4.67527L21.7616 4.27854ZM3.57211 5.46387L11.9566 1.80514L20.3412 5.46387C21.1403 9.38447 20.5021 17.5863 11.9566 22.1403C3.41113 17.5863 2.77302 9.38448 3.57211 5.46387ZM11.334 14.6786L17.09 8.92265L15.9114 7.74414L11.334 12.3216L9.58996 10.5775L8.41145 11.756L11.334 14.6786Z",
  fill: "white"
});

function SvgFooterPaintProtectionFilm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPaintProtectionFilm);
export default __webpack_public_path__ + "static/media/footer-paint-protection-film.c3644bca.svg";
export { ForwardRef as ReactComponent };